import {Base} from "./Base";

export enum RoleType {
    Superadmin = 'Superadmin',
    Administrator = 'Administrator',
    Warehouseman = 'Magacioner',
    Logistician = 'Logističar',
    Commercialist = 'Komercijalista',
    CommercialistII = 'Komercijalista II',
    Backoffice = 'Backoffice',
    ControlHouse = 'Kontrolna kuća',
    Director = 'Direktor',
    FinishingCenter = 'Doradni centar'
}

export interface Role extends Base {
    id: string
    name?: RoleType
}
